export const BrandColours = {
	BrightBlue: '#A8E8EC',
	MidBlue: '#70DADF',
	Blue: '#2B42FA',
	Purple: '#DBB2FC',
	DarkPurple: '#B878E3',
	Pink: '#FFBAEB',
	Green: '#59EB96',
	Grey: '#58595B',
	Yellow: '#FFF57A',
	Orange: '#FFA159',
	MidWhite: '#FEFEF8',
	PearlWhite: '#FCFFED',
	TawnyWhite: '#E6E2D3',
};

export function getBrandColour(key: string, location?: string) {
	const trimmed = key?.trim() || '';
	if (!(trimmed in BrandColours)) {
		console.log(!trimmed ? 'No colour given' : 'Colour not found in BrandColours:', trimmed, location);
		return BrandColours.BrightBlue;
	}
	return BrandColours[trimmed as keyof typeof BrandColours];
}

export function getColourBackground(colour: string) {
	if (colour in BrandColorToTailwind) {
		return BrandColorToTailwind[colour as keyof typeof BrandColorToTailwind];
	}
	return '';
}

export const BrandColorToTailwind = {
	'#A8E8EC': 'bg-bright-blue',
	'#70DADF': 'bg-mid-blue',
	'#2B42FA': 'bg-blue',
	'#DBB2FC': 'bg-purple',
	'#B878E3': 'bg-dark-purple',
	'#FFBAEB': 'bg-pink',
	'#59EB96': 'bg-green',
	'#58595B': 'bg-grey',
	'#CDCDCE': 'bg-grey-light',
	'#FFF57A': 'bg-yellow',
	'#FFA159': 'bg-orange',
	'#FFFFFF': 'bg-white',
	'#FEFEF8': 'bg-mid-white',
	'#FCFFED': 'bg-pearl-white',
	'#E6E2D3': 'bg-tawny-white',
};
